import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './home.scss';
import SearchGeneral from '../../../components/content/searchs/search_general/SearchGeneral';
import { useWordService } from '../../../core/hooks/services/word.service';

export default function Home({ setPageTitle }: any) {

  // Nombre de la página
  const namePage = 'Inicio';

  useEffect(() => {

    // Titulos de pagina
    setPageTitle(namePage);
    document.title = `${namePage} | SeñaTech`;

  }, [setPageTitle]);



  // Llamada al servicio de diccionario
  const { content, loading, error } = useWordService();
  const [dataWord, setDataWord] = useState({});

  useEffect(() => {

    // Función para obtener los datos del diccionario al montar el componente
    const fetchData = async () => {
      const result = await content();
      if (result) {
        setDataWord(result.data.word)
      }
    };

    fetchData();
  }, []);


  return (
    <section className='page content_home'>

      <div className='search_content'>

        <h1 className='title'>Diccionario de Lengua de Señas Ecuatoriana SeñaTech</h1>

        <div className='search'>
          <SearchGeneral data={dataWord} showInitialResults={true} />
        </div>
      </div>

      <div className='cards_content'>
        <Link to={'/c/alfabetico'} className='card'>
          <i className="fa-regular fa-arrow-down-a-z"></i>
          <h2 className='title'>Alfabético</h2>
          <span className='description'>Revise nuestro diccionario con indice alfabético.</span>
        </Link>

        <Link to={'/c/conceptos-tecnicos'} className='card'>
          <i className="fa-solid fa-bolt"></i>
          <h2 className='title'>Conceptos Técnicos</h2>
          <span className='description'>Revisa las frases técnicas en lenguaje de señas.</span>
        </Link>

        <Link to="/contacto" className='card'>
          <i className="fa-regular fa-envelope"></i>
          <h2 className='title'>Contáctanos</h2>
          <span className='description'>Danos tu opinión de este diccionario, llenando el siguiente formulario.</span>
        </Link>
      </div>

    </section>
  )
}
